import React, { PureComponent, ReactNode } from 'react'
import { RouteComponentProps, withRouter } from '../../../helpers/withRouter'
import { connectRedux } from '../../../helpers/connectRedux'
import { IStoreState } from '../../../store/states'
import { Page } from '../../../components'
import LanguageSelector from '../../../containers/LanguageSelector'
import { SignUpStep1Form, SIGN_UP_STEP_TITLES } from '../../../containers/SignUpForms'
import { images } from '../../../images'
import { urls } from '../../../routing'
import { LiteralsService } from '../../../services'
import StyledArticle from '../styles'
import { appsLogosSelected, appsStyleSelected } from '../../../helpers/app'

// The fields and their rules live in SignUpStep1Form, shared with the prompt shown to guests.
interface IProps extends RouteComponentProps {
  language: string
  embedded?: boolean
}

class SignUpStep1 extends PureComponent<IProps> {
  public render(): ReactNode {
    if (this.props.embedded) return this.card

    return (
      <Page className={ appsStyleSelected?.style }>
        <StyledArticle>
          <div className="language-selector">
            <LanguageSelector />
          </div>
          { this.card }
        </StyledArticle>
      </Page>
    )
  }

  private get card(): ReactNode {
    return (
      <form onSubmit={ e => e.preventDefault() }>
        <img src={ images['goBack'] } className="backButton" onClick={ this.handleGoBack } alt="" />
        <header>
          <img  className={ appsLogosSelected?.classRounded }
                src={ appsLogosSelected?.logoRounded }
                alt={ appsLogosSelected?.alt } />
          <h2>{ LiteralsService.get(SIGN_UP_STEP_TITLES[0], true) }</h2>
        </header>
        <SignUpStep1Form onContinue={ this.goToStep2 } onSignIn={ this.goToSignIn } />
      </form>
    )
  }

  private goToStep2 = (): void => {
    this.props.history.push(urls.signUpStep2)
  }

  private goToSignIn = (): void => {
    this.props.history.push(urls.signIn)
  }

  private handleGoBack = (): void => {
    history.back()
  }
}

// Redraws the literals when the language selector changes the language.
const mapStateToProps = ({ configuration }: IStoreState) => ({
  language: configuration.language
})

export default withRouter(connectRedux(mapStateToProps, SignUpStep1))
